
// HammerJS is optional for Angular Material gesture support (e.g., sliders, swipe).
// Currently commented out during upgrade. If touch gestures or slide components fail,
// add HammerJS to package.json and install a version compatible with project's Angular version.

// import 'hammerjs'; 
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => console.error(err));
